import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import Table from '../../../clientModule/components/Common/Table/Table';
import { TableHeader, TableWrapper } from '../../../clientModule/components/Common/Table/types';
import useFilterActions from '../../../../pages/Responsive/useFilterActions';
import { PermittingDocumentType } from '../../../../api/jurisdiction';
import { useGetVocabularyQuery } from '../../../../redux/rtkQuery/apiSlice';
import { filterMeta, headers } from './PermittingDocumentsTableData';
import { setPermittingDoc } from '../../../../redux/slices/wikiSlice';
import { useDeleteWikiPermittingDocumentMutation } from '../../../../redux/rtkQuery/apiWikiPermittingSlice';

const PermittingDocumentsTable = ({ records, setShowAddDocument }) => {
  const { data: vocaWork } = useGetVocabularyQuery(2);
  const { data: vocaBuilding } = useGetVocabularyQuery(1);
  const { data: vocaPermitType } = useGetVocabularyQuery(14);
  const { data: vocaDocumentType } = useGetVocabularyQuery(13);
  const [deleteWikiPermittingDocument] = useDeleteWikiPermittingDocumentMutation();
  const dispatch = useDispatch();
  const filteredRows = useFilterActions(records);

  const onEdit = (item: PermittingDocumentType) => {
   const building = vocaBuilding.results.find(b => b.id === item.building);
   const work = vocaWork.results.find(w => w.id === item.work);
   const permitType = vocaPermitType.results.find(pt => pt.id === item.permitType);
   const documentType = vocaDocumentType.results.find(dt => dt.id === item.wikiDocumentType);
   const _permittingDoc = {
         building: { label: building.title, value: building.id },
         documentName: item.documentName,
         documentType: { label: documentType.title, value: documentType.id },
         fileName: item.permittingVisibleFilename,
         permitType: { label: permitType.title, value: permitType.id },
         work: { label: work.title, value: work.id },
         isEditing: true,
         id: item.id,
       };
       dispatch(setPermittingDoc(_permittingDoc));
       setShowAddDocument(true);
  };

  const onDelete = async (item: PermittingDocumentType) => {
   await deleteWikiPermittingDocument({ id: item.id });
  };
  return (
    <TableWrapper1>
      <Table
        collection={filteredRows}
        headers={headers}
        filterMeta={filterMeta}
        gridTemplateCols="1fr 1fr 1fr 83px"
        onDelete={onDelete}
        onEdit={onEdit}
      />
    </TableWrapper1>
  );
};

export default PermittingDocumentsTable;

const Wrapper = styled.div`
  min-height: 300px;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const TableWrapper1 = styled(TableWrapper)`
  height: 40vh;
`;
